<template>
  <div
    class="flex justify-between w-full cursor-pointer space-x-4"
    @click="toggleIsTagsIsCollapsed"
  >
    <label :for="context.id" class="font-medium text-sm">
      {{ context.label }}
    </label>
    <div class="flex flex-row flex-shrink-0">
      <span class="text-xs mt-1 mr-3">{{ count }} selected</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="w-5 h-5 transition-all duration-300"
        :class="{ '-rotate-180': isCollapsed }"
      >
        <path
          fill-rule="evenodd"
          d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { EventBus } from '../../../js/plugins/event-bus'
import { EVENT_KEYS } from '../../../js/util/constants.js'

export default defineComponent({
  name: 'VueFormulateTagsLabelSlot',

  props: {
    context: {
      type: Object,
      required: true,
    },

    count: {
      type: Number,
      required: true,
    },

    isCollapsed: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const toggleIsTagsIsCollapsed = () => {
      const type = props.context.name
      EventBus.$emit(EVENT_KEYS.CO_VUE_FORMULATE_TAGS_TOGGLE_COLLAPSED, type)
    }

    return {
      toggleIsTagsIsCollapsed,
    }
  },
})
</script>
